var gift = "https://shopfront-cdn.tekoapis.com/static/2b8403d1ea147a23.svg";

export { gift as default };
